import { IApiTag, ITag } from 'types';

export const convertTagsToAppSchema = (tags: IApiTag[]): ITag[] => {
  return tags.map(({ color, name }) => ({ color, name }));
};
